.reverse {
  svg {
    transform: scaleY(-1);
  }
}

.list {
  display: flex;
  flex-direction: column;
  padding: 8px;
  min-width: 250px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-radius: 8px;

  &:hover {
    background: var(--dark-05);
  }
}

.avatarStack {
  display: flex;
  align-items: center;
}

.avatar {
  overflow: unset;
}

.avatarChip {
  position: relative;
  border-radius: 50%;
  box-shadow: 0 0 0 2px var(--light-100);

  &:not(:first-child) {
    margin-left: -8px;
  }
}

.platformBadge {
  position: absolute;
  right: -2px;
  bottom: -3px;
}

.overflowChip {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  margin-left: 4px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--dark-05);
  color: var(--dark-80);
  font-size: 13px;
  font-weight: 500;
}

.connectRow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  border: none;
  background: none;
  cursor: pointer;
  width: 100%;

  &:hover {
    background: var(--dark-05);
  }
}
